import React from 'react'
import GiftListItem, {
  GiftContent, GiftIcon, GiftItem, GiftTitle,
} from '../styles/giftListItem'
import Score from './Score'

export default ({
  icon,
  description: {
    title,
    summary
  },
  price,
  isDisabled,
  isInvert,
  onClick,
  collapsed,
  height,
  marginBottom,
}) =>
  <GiftListItem
    className={isDisabled ? 'disabled' : isInvert ? 'inverted' : ''}
    onClick={onClick}
    collapsed={collapsed}
    height={height}
    marginBottom={marginBottom}
  >
    <GiftIcon src={icon} />
    <GiftItem>
      <GiftTitle>
        {title}
      </GiftTitle>
      <GiftContent>
        {summary}
      </GiftContent>
    </GiftItem>
    <Score status={isDisabled ? 'inactive' : 'active'}>
      {price}
    </Score>
  </GiftListItem>
